
var TECL_Filter = {
    FilterResults: function(e, freeTextSearchTerm, numberOfColumns, pageControl) {
        e.preventDefault();
        var featureElementsOnPage = $('.hero-feature-item').length;
        var pageNumber = 1;
        var currentPage = $("#pageNumber").val();
        var currentPageNumber = parseInt(currentPage);
        if (pageControl === 'INITIAL') {
            pageNumber = 1;
        } else if (pageControl === 'NEXT') {
            //Get current page
            pageNumber = currentPageNumber + 1;
        } else if (pageControl === 'PREV') {
            pageNumber = currentPageNumber - 1;
        } else if (pageControl === 'RELOAD') {
            pageNumber = currentPageNumber;
        } else {
            pageNumber = parseInt(pageControl);
        }

        var items = $("#filter-form");
        var filterItemsArray = items.serializeArray();
        var filterItems = JSON.stringify(filterItemsArray);

        var myFilterItems = {};
        var availableFilterItems = [];
        $("#filter-form input").each(function(element) {
            var filterName = $(this).attr("data-filter-name");
            var filterValue = $(this).attr("data-filter-value");

            if (availableFilterItems.indexOf(filterName) == -1) {
                availableFilterItems.push(filterName);
            }

            if ($(this).is(':checkbox:checked')) {
                myFilterItems[filterName] = myFilterItems[filterName] || [];
                myFilterItems[filterName].push(filterValue);
            }

            //handle range sliders.
            if ($(this).attr("data-slider-min") !== undefined) {
                filterName = $(this).attr("name");
                filterValue = $(this).attr("data-value");
                var splitValue = filterValue.split(',');
                var splitVal1 = splitValue[0];
                var splitVal2 = splitValue[1];
                var filterMin = $(this).attr("data-slider-min");
                var filterMax = $(this).attr("data-slider-max");
                if (filterMin === splitVal1 && filterMax === splitVal2) {
                    //Do nothing. We don't want to bother attempting to filter a property for a full range.
                } else {
                    myFilterItems[filterName] = myFilterItems[filterName] || [];
                    myFilterItems[filterName].push(filterValue);
                }
            }

            //Handle free text term
            if ($(this).attr("name") === "freeTextSearchTerm") {
                var filterName = "query";
                var filterValue = $(this).val();
                myFilterItems[filterName] = myFilterItems[filterName] || [];
                myFilterItems[filterName].push(filterValue);
            }
        });

        var newPageUrl = window.location.href;
        var wholeUrl = newPageUrl.split("?");

        var existingFilters;

        if (wholeUrl.length > 1) {
            existingFilters = wholeUrl[1].split("&");
            $.each(existingFilters, function(key, value) {
                var existingFilterName = value.split("=")[0];
                if (availableFilterItems.indexOf(existingFilterName) > -1) {
                    newPageUrl = TECL_Filter.UpdateQueryString(existingFilterName, "", newPageUrl);
                }
            });
        }

        $.each(myFilterItems, function(key, value) {
            if (String(value).length > 0) {
                newPageUrl = TECL_Filter.UpdateQueryString(key, encodeURIComponent(value), newPageUrl);
            }
        });

        var activeTab = $("#searchListingTabs").find(".active").attr("data-value") || "";
        window.history.pushState({}, "", newPageUrl);
        var url = "/umbraco/Surface/SearchResultsSurface/FilterResults";

        $(".searchResultItems").html("<div class=\"ajax-content-loading\">" +
                                       "<div class=\"ajax-content-loading-content\"></div>" +
                                     "</div>" +
                                     "<span class=\"ajax-content-loading-message\">Loading...</span>");
        $("body, html").animate({
            scrollTop: $(".searchResults").offset().top - 150
        }, 500);

        //Try to get existing orderBy from q string
        var orderBy = TECL_Filter.GetParameterByName('orderby');
        var itemsPerPage = TECL_Filter.GetParameterByName('itemsperpage');

        $.ajax({
            url: url,
            data: {
                filterData: filterItems,
                freeTextSearchTerm: freeTextSearchTerm,
                numberOfColumns: numberOfColumns,
                pageNumber: pageNumber,
                resultItemsPartialViewName: $("#productListingType").val(),
                activeTab: activeTab,
                orderBy: orderBy,
                itemsPerPage: itemsPerPage
            },
            cache: false,
            type: "POST",
            success: function(data) {
                var filterTerms = "";
                for (var i = 0; i < filterItemsArray.length; i++) {
                    var obj = filterItemsArray[i];
                    var name = obj.name;
                    var categoryAndValue = name.split(",");
                    if (name !== "DocumentType") {
                        if (filterTerms === "") {
                            filterTerms = categoryAndValue[0] + " - " + categoryAndValue[1];
                        } else {
                            filterTerms = filterTerms + ", " + categoryAndValue[0] + " - " + categoryAndValue[1];
                        }
                    }
                }
                if (filterTerms !== "") {
                    $("#filterTerms").replaceWith("<div class=\"filterTerms\" id=\"filterTerms\"><h3>Filtered by: " + filterTerms + "</h3></div>");
                } else {
                    $("#filterTerms").replaceWith("<div class=\"filterTerms\" id=\"filterTerms\"></div>");
                }
                if (data.length !== 0) {
                    var searchResults = data.SearchResults;
                    $(".searchResultItems").replaceWith(searchResults);
                    //$(".sliderProperty").slider();

                    $("#productCount").text("(" + String(data.SearchResultItemsCount) + ")");

                    //set the new page number
                    $("#pageNumber").val(data.PageNumber);
                    $(".pageNumber").text(data.PageNumber);

                    // Create an array containing a value for each valid page number
                    var pages = [];
                    for (var i = 1; i <= data.TotalPages; i++) {
                        pages.push(i);
                    }

                    if (pages.length == 0) {
                        pages.push(0);
                    }
                    // Regenerate select2 options to contain only valid page numbers
                    $(".pagination-select").select2('destroy').empty().select2({ data: pages });

                    // Set the current option to the selected page number
                    $(".pagination-select").val(data.PageNumber).trigger('change.select2');

                    window.history.pushState(
                      {}, "", TECL_Filter.UpdateQueryString("page", data.PageNumber, null)
                    );

                    // Set the total page count to the new total
                    $(".total-page-count").text(data.TotalPages);

                    // Disable buttons that won't work
                    if (data.PageNumber <= 1) {
                        $(".btn.previous").prop("disabled", true);
                    } else {
                        $(".btn.previous").prop("disabled", false);
                    }
                    if (data.MoreResultsAvailable) {
                        $(".btn.next").prop("disabled", false);
                    } else {
                        $(".btn.next").prop("disabled", true);
                    }
                } else {
                    data.Count = 0;
                }
            },
            error: function(xhr, status, error) {
                console.log(xhr.responseText);
                alert("message : \n" +
                      "An error occurred, for more info check the js console" +
                      "\n status : \n" +
                      status +
                      " \n error : \n" +
                      error);
            }
        });
    }
  ,
    SaveSearch: function(e, freeTextSearchTerm) {
        e.preventDefault();
        var items = $("#filter-form");
        var filterItemsArray = items.serializeArray();
        var filterItems = JSON.stringify(filterItemsArray);
        var currentPageUrl = window.location.href;

        var url = "/umbraco/Surface/SearchResultsSurface/SaveSearchResults";
        $.ajax({
            url: url,
            data: {
                filterData: filterItems,
                freeTextSearchTerm: freeTextSearchTerm,
                currentPageUrl: currentPageUrl
            },
            cache: false,
            type: "POST",
            success: function(data) {
                if (data.length !== 0) {
                    var message = "";
                    if (data.Error !== undefined) {
                        message = data.Error;
                    } else {
                        message = "You can access your saved search here: ";
                    }

                    var clipboard = new Clipboard("#copyToClipboardButton");
                    clipboard.on('success', function(e) {
                        $("#copySuccessMessage").text("Copied to clipboard.");
                        e.clearSelection();
                    });

                    clipboard.on('error', function(e) {
                        console.error('Action:', e.action);
                        console.error('Trigger:', e.trigger);
                        $("#copySuccessMessage").text("Use Ctrl-C to copy the Url.");
                    });

                    $("#savedSearchMessage").text(message);
                    $("#savedSearchUrl").attr("href", data.SearchUrl);
                    $("#savedSearchUrl").text(data.SearchUrl);
                    $("#savedSearchUrlInput").val(data.SearchUrl);
                    $("#savedSearchModal").modal('show');
                }
            },
            error: function(xhr, status, error) {
                console.log(xhr.responseText);
                alert("message : \n" +
                      "An error occurred, for more info check the js console" +
                      "\n status : \n" +
                      status +
                      " \n error : \n" +
                      error);
            }
        });
    }
  ,
    UpdateQueryString: function(key, value, url) {
        if (!url) {
            url = window.location.href;
        }

        var newString = "";
        var re = new RegExp("[\\?&]" + key + "=([^&#]*)"), match = re.exec(url), delimiter, newString;

        if (match === null) {
            // append new key
            var hasQuestionMark = /\?/.test(url);
            delimiter = hasQuestionMark ? "&" : "?";
            if (value != "") {
                newString = url + delimiter + key + "=" + value;
            }
        } else {
            delimiter = match[0].charAt(0);
            if (value != "") {
                newString = url.replace(re, delimiter + key + "=" + value);
            } else {
                newString = url.replace(re, "");
            }
        }

        var hasQuestionMark = /\?/.test(newString);
        if (!hasQuestionMark) {
            var hasAmpersand = /\&/.test(newString);
            if (hasAmpersand) {
                newString = newString.replace("&", "?");
            }
        }

        return newString;
    }
  ,
    ApplySort: function() {
        var sortToApply = $("#selectSortBy").val();
        $("#orderBy").val(sortToApply);
        var pageUrl = window.location.href;
        var newPageUrl = TECL_Filter.UpdateQueryString("orderby", encodeURIComponent(sortToApply), pageUrl);
        window.history.pushState({}, "", newPageUrl);
        location.reload();
    }
  ,
    GetParameterByName: function getParameterByName(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }
};

$(document).ready(function (e) {
  var ajaxTimer = "";

  $(document).on("click", "#FilterButton", function (e) {
    TECL_Filter.FilterResults(e, $("#freeTextSearchTerm").val(), 3, 'INITIAL');
  });

  $(document).on("keydown", "#freeTextSearchTerm", function (e) {
    if (e.keyCode == 13) {
      $("#FilterButton").click();
    }
  });

  $(document).on("change", "#filter-form :checkbox", function(e) {
    if($( window ).width() > 768) {
      $("#FilterButton").click();
    }
  });

  $(document).on("slideStop", "#filter-form .sliderProperty", function(e) {
    if($( window ).width() > 768) {
      $("#FilterButton").click();
    }
  });

  $(".pagination-select").on("change", function (e) {
     TECL_Filter.FilterResults(e, $("#freeTextSearchTerm").val(), 3, $(this).val());
   });
});
